export default async function initFeefoSummary() {
    const widgets = document.querySelectorAll('[data-feefo-summary]');
    if (!widgets.length) return;
    widgets.forEach(loadFeefoAward);

    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 10000);
    try {
        const response = await fetch('https://api.feefo.com/api/20/reviews/summary/service?merchant_identifier=the-store-room&since_period=all', {
            signal: controller.signal,
        });
        if (!response.ok) throw new Error('Feefo summary unavailable');
        const summary = await response.json();
        const score = summary.rating?.rating;
        const count = summary.meta?.count;
        if (!Number.isFinite(score) || score < 0 || score > 5 || !Number.isInteger(count) || count <= 0) {
            throw new Error('Invalid Feefo summary');
        }

        widgets.forEach((widget) => {
            widget.querySelector('[data-feefo-score]').textContent = score.toFixed(1);
            widget.querySelector('[data-feefo-rating]').hidden = false;
            const stars = widget.querySelector('[data-feefo-stars]');
            stars.querySelectorAll('[data-feefo-star]').forEach((star, index) => {
                const fill = Math.min(1, Math.max(0, score - index));
                star.style.setProperty('--star-empty', `${Number(((1 - fill) * 100).toFixed(2))}%`);
            });
            stars.hidden = false;
            const verified = summary.meta.verified_count === count ? ' verified' : '';
            const description = widget.querySelector('[data-feefo-description]');
            if (description) description.textContent = ` based on ${count.toLocaleString('en-GB')}${verified} reviews.`;
        });
    } catch {
        widgets.forEach((widget) => {
            const description = widget.querySelector('[data-feefo-description]');
            if (description) description.textContent = ' from our customers.';
        });
    } finally {
        clearTimeout(timeout);
    }
}

async function loadFeefoAward(widget) {
    const badge = widget.querySelector('[data-feefo-award]');
    if (!badge) return;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 10000);
    try {
        const response = await fetch('https://api.feefo.com/api/merchants/widgetintegration/all?merchant_identifier=the-store-room', {
            signal: controller.signal,
        });
        if (!response.ok) return;
        const settings = await response.json();
        const awards = {
            TRUSTED: ['feefo-trusted-service-award.svg', 'Trusted Service Award'],
            GOLD: ['feefo-gold-service-award.svg', 'Gold Trusted Service Award'],
            PLATINUM: ['feefo-platinum-service-award.svg', 'Platinum Trusted Service Award'],
        };
        const award = Object.hasOwn(awards, settings.serviceAwardLevel) ? awards[settings.serviceAwardLevel] : null;
        if (!award) return;
        const image = badge.querySelector('[data-feefo-award-image]');
        image.onload = () => { badge.hidden = false; };
        image.onerror = () => { badge.hidden = true; };
        image.alt = `Feefo ${award[1]}`;
        image.src = `https://public.feefo.com/images/${award[0]}`;
    } catch {

    } finally {
        clearTimeout(timeout);
    }
}
